import { render, staticRenderFns } from "./pricing.page.vue?vue&type=template&id=4c28be61&scoped=true&"
import script from "./pricing.page.vue?vue&type=script&lang=js&"
export * from "./pricing.page.vue?vue&type=script&lang=js&"
import style0 from "./pricing.page.vue?vue&type=style&index=0&id=4c28be61&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c28be61",
  null
  
)

export default component.exports